import { VotingConstants } from "../../constants/voting.constants";
import { getAllVoting } from "./get-voting";
import { message } from "antd";
import editMainInfo from "./utils/editMainInfo";
import checkQuestions from "./utils/checkQuestions";
import checkAddresses from "./utils/checkAddresses";
import checkFiles from "./utils/checkFiles";

const editVoting = (updatedVoting) => async (dispatch, getState) => {
	const {
		votingStore: {
			voting: savedVoting,
			addresses: { addresses },
		},
	} = getState();
	try {
		dispatch({ type: VotingConstants.ITEM_LOADING });
		await editMainInfo(updatedVoting, savedVoting);
		await checkQuestions(savedVoting, updatedVoting);
		await checkAddresses(savedVoting, updatedVoting, addresses);
		await checkFiles(savedVoting, updatedVoting);
		dispatch({ type: VotingConstants.ITEM_LOADED });
		dispatch(getAllVoting());
	} catch (e) {
		console.error(e);
		message.error("Не получилось изменить опрос");
	}
};

export default editVoting;
